//Replace any underscore with space and capitalize all words of a string
export function customizeText(value) {
  if (typeof value !== 'string' || !value) return '';
  if (value)
    return value.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  return '';
}
